import { Controller } from '@hotwired/stimulus'
import * as bootstrap from 'bootstrap'

export default class OtpModalController extends Controller {
  static targets = ['form', 'errorMessage', 'otpInput']

  static values = {
    bankAccountPath: String,
    payoutPath: String,
    newPayoutPath: String,
    genericError: String
  }

  connect() {
    this.modal = new bootstrap.Modal(this.element)
  }

  show() {
    this.modal.show()
  }

  hide() {
    this.modal.hide()
  }

  async submit(event) {
    event.preventDefault()

    const formData = new FormData(this.formTarget)

    try {
      const response = await fetch(this.formTarget.action, {
        method: 'PUT',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        },
        body: formData
      })

      const data = await response.json()
      this.#handleResponse(data)
    } catch (error) {
      this.#showError(this.genericErrorValue)
    }
  }

  #handleResponse(data) {
    switch (data.action) {
      case 'error':
        this.#showError(data.error)
        break
      case 'submit_bank_account':
        this.#hideError()
        this.#autoSubmitBankAccount()
        break
      case 'submit_payout':
        this.#hideError()
        this.#autoSubmitPayout()
        break
      case 'redirect_to_payout':
        this.#hideError()
        this.hide()
        window.location.href = this.newPayoutPathValue
        break
    }
  }

  #showError(message) {
    this.errorMessageTarget.innerHTML = message
    this.errorMessageTarget.classList.remove('d-none')
    if (this.hasOtpInputTarget) {
      this.otpInputTarget.classList.add('border-danger')
    }
  }

  #hideError() {
    this.errorMessageTarget.classList.add('d-none')
    if (this.hasOtpInputTarget) {
      this.otpInputTarget.classList.remove('border-danger')
    }
  }

  async #autoSubmitBankAccount() {
    try {
      const response = await fetch(this.bankAccountPathValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      const data = await response.json()
      this.#delegateToBankAccountController(data)
    } catch (error) {
      toastr.error(this.genericErrorValue)
    }
  }

  async #autoSubmitPayout() {
    try {
      const response = await fetch(this.payoutPathValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      const data = await response.json()
      this.#handlePayoutResponse(data)
    } catch (error) {
      toastr.error(this.genericErrorValue)
    }
  }

  #delegateToBankAccountController(data) {
    const container = document.querySelector('#bankAccountContainer')
    if (container) {
      const controller = this.application.getControllerForElementAndIdentifier(container, 'bank-account-form')
      if (controller) {
        controller.handleResponse(data)
      }
    }
  }

  #handlePayoutResponse(data) {
    this.hide()
    if (data.success) {
      toastr.success(data.message)
      if (data.redirect_to) {
        window.location.href = data.redirect_to
      }
    } else {
      toastr.error(data.error)
    }
  }
}
